<!--核心团队集合-->
<template>
  <div>
    <h1 style="text-align: center;margin-top: 20px;background-color: #ffbebe;color: red">WE</h1>
    <transition-group
        appear
        name="animate__animated animate__bounce"
        enter-active-class="animate__bounceInRight"
    >
    <CoreTeamItem
        v-for="teamObj in teamList"
        :key="teamObj.id"
        :team="teamObj"
        style="margin: auto;margin-top: 20px;margin-bottom: 20px"
    />
    </transition-group>
  </div>
</template>

<script>
import CoreTeamItem from "@/components/team/CoreTeamItem";
import axios from "axios";
export default {
  name: "CoreTeamList",
  components: {CoreTeamItem},
  data(){
    return {
      teamList: []
    }
  },
  mounted() {
    axios.get('http://121.40.117.227:9091/users').then(
        response => {
          this.teamList = response.data.data
        },
        error => {
          console.log('请求失败！',error.message)
        }
    )
  }
}
</script>

<style scoped>

</style>
